import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LOGO_ICON = "https://customer-assets.emergentagent.com/job_real-estate-hub-147/artifacts/e5h2jhc8_LOGO_Graphique.png";
const LOGO_TEXT = "https://customer-assets.emergentagent.com/job_real-estate-hub-147/artifacts/tdjh637n_LOGO_Titre.png";

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);
  // phase 0: icon fades in (0-0.8s)
  // phase 1: icon moves up, text fades in (0.8-2s)
  // phase 2: hold (2-2.5s)
  // phase 3: fade out (2.5-3s)

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 800);
    const t2 = setTimeout(() => setPhase(2), 2000);
    const t3 = setTimeout(() => setPhase(3), 2500);
    const t4 = setTimeout(() => onComplete(), 3200);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase < 3 && (
        <motion.div
          data-testid="splash-screen"
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ backgroundColor: "#103757" }}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
        >
          <div className="flex flex-col items-center">
            {/* Logo icon */}
            <motion.img
              src={LOGO_ICON}
              alt="29"
              className="w-48 h-48 object-contain"
              initial={{ opacity: 0, y: 0 }}
              animate={{
                opacity: 1,
                y: phase >= 1 ? -30 : 0,
              }}
              transition={{
                opacity: { duration: 0.6, ease: "easeOut" },
                y: { duration: 0.6, ease: "easeInOut" },
              }}
            />

            {/* Logo text */}
            <motion.img
              src={LOGO_TEXT}
              alt="Vingt-Neuf Immobilier"
              className="h-20 object-contain mt-4"
              style={{ filter: "brightness(2)" }}
              initial={{ opacity: 0 }}
              animate={{
                opacity: phase >= 1 ? 1 : 0,
              }}
              transition={{
                opacity: { duration: 0.6, ease: "easeOut", delay: 0.2 },
              }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
